import React from 'react';
import PropTypes from 'prop-types';

import { PrintSize } from '../prop-types';
import Currency from '../../_utils/tools/currency';
import RecommendedPrintSizeBadge from '../common/photo-quality/recommended-print-size-badge';
import RawPhotoLowResolutionBadge from '../common/photo-quality/raw-photo-low-resolution-badge';
import CroppedTooSmallBadge from '../common/photo-quality/cropped-too-small-badge';

export function PrintSizeButton({
  title,
  price,
  printSizeKey,
  sizesWithPrints,
  onClick,
  badgeType,
}) {
  const isDisabled = !!(sizesWithPrints || []).find(
    (size) => size.key === printSizeKey,
  );

  return (
    <button
      type="button"
      className="btn btn-link btn-block size-options__size"
      disabled={isDisabled}
      onClick={() => onClick(printSizeKey)}>
      {badgeType === 'raw_photo_low_res' && (
        <RawPhotoLowResolutionBadge
          tooltipPosition="bottom"
          tooltipCSSClasses="mobile"
        />
      )}
      {badgeType === 'cropped_too_small' && (
        <CroppedTooSmallBadge
          tooltipPosition="bottom"
          tooltipCSSClasses="mobile"
        />
      )}
      <strong>{title}</strong> ({Currency.format(price)})
      {isDisabled && ' - Already added'}
      {badgeType === 'recommended' && (
        <RecommendedPrintSizeBadge className="ml-2" />
      )}
    </button>
  );
}

PrintSizeButton.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  printSizeKey: PropTypes.string.isRequired,
  sizesWithPrints: PropTypes.arrayOf(PrintSize),
  onClick: PropTypes.func.isRequired,
  badgeType: PropTypes.string,
};
